<template>
    <v-col cols="12" md="6" align="center" class="pr-5">
        <v-col cols="12" align="start" class="ml-4 mt-4 color-text text-h5">
            {{ $t('profile.your_collection') }}
        </v-col>
        <v-card
            class="px-6 pb-6 pt-3 pt-xl-6 bg-favorites"
            elevation="12"
            :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?250:230"
            to="/user/library"
        >
            <v-row  align="center">
                <v-col cols="7" xl="9" class="white--text text-left text-h4 font-weight-regular">
                    {{ $t('profile.your_favorite_books') }}
                </v-col>
                <v-col cols="6" xl="9" class="white--text">
                    <p class="py-2 text-left text-subtitle-1 text-lg-subtitle-1">
                        {{ $t('profile.your_favorite_books_desc') }}
                    </p>
                </v-col>
            </v-row>
            <v-overlay absolute value="true" opacity="0" class="overlay">
                <v-img
                    src="/img/user/books-bg.svg"
                    max-height="200"
                    :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?180:270"
                ></v-img>
            </v-overlay>
        </v-card>
    </v-col>
</template>

<script>
export default {
    
}
</script>
<style scoped>
.v-card {
    border-radius: 20px;
}
.bg-favorites {
    background: #2DBBAD;
}
.overlay {
    justify-content: flex-end;
    margin-right: -8px;
    padding-top: 80px;
}
@media (max-width: 1263px) {
    .overlay {
        padding-top: 150px;
    }
}
</style>